<template>
  <div class="main-container-l">
    <div class="loading-container" v-if="loading"><img src="../../assets/img/loading.svg"></div>
    <div class="results-menu-l lotto-results" v-if="isMobile">
        <router-link v-if="showLottoOfferButton" class="button button-mobileLoto mbutton-results-lotto full" :to="{ path: '/web/lotto/' }">{{$t('LOTTOOFFER')}}</router-link>
        <ResultsPageRoutes v-on:toggleCalendar="toggleCalendar" v-bind:showCalendar="showCalendar" />
      <Calendar v-show="showCalendar" :otherStartDate="startDate" v-on:selectDate="changeDate"></Calendar>
    </div>
    <div class="offer-container-l">
      <div class="games-menu lotto-menu-container lotto-menu-results" v-if="!isMobile">
         <!-- loto item -->
          <!--div class="gamesm-item" v-for="lotto in lottosDef" :key="lotto.lottoOfferId" v-on:click="selectedLottos = lotto" :class="(selectedLottos == lotto) ? 'is-selected' : ''">
              <div class="gamesm-item-content" :class="'game' + lotto.lottoId">
                  <div class="gamesm-content-left">
                      <span class="loto-country-flag" :class="'lotto-flag-'+lotto.lottoId"> </span> {{lotto[0].name}}
                  </div>
                  <div class="gamesm-content-right">
                      <div class="gamesm-text">{{lotto.length}}</div>
                  </div>
              </div>
          </div-->
          <div class="filterlotochange">
            <label for="tab1" class="filter-label" :class="{'is-selected': (tab == 'countries')}" v-on:click="tab = 'countries'">{{$t('COUNTRY')}}</label>
            <label for="tab2" class="filter-label" :class="{'is-selected': (tab == 'lottos')}" v-on:click="tab = 'lottos'">{{$t('LOTTO')}}</label>

            <div class="contentfilter">
                <div  v-if="tab == 'countries'">
                    <ul class="gamesm-item"
                    v-for="country in countriesList"
                    v-bind:key="country.countryId"
                    v-on:click="countries[country.countryId].selected = !countries[country.countryId].selected">
                        <li>
                        <label class="gamesm-item-box" >
                            <div class="gamesm-content-left">
                            <div class="filterLeft-icon">
                                <span class="ggame-heading-icon lb-flag" :class="'flag-'+lottoMapping[country.lottoId]"></span>
                            </div>{{country.name}}</div>
                            <div class="gamesm-content-right" :class="{'is-selected': (countries[country.countryId].selected)}">
                            <div class="gamesm-arrow">&nbsp;</div>
                            </div>
                        </label>
                        <ul class="submenu" v-if="(countries[country.countryId].selected)">
                            <li class="submenu-item"
                            :class="{'is-selected': (selectedLottos === lotto.lottoId)}"
                            v-for="(lotto) in countries[country.countryId].lottosList"
                            v-on:click.stop="selectLottos(lotto.lottoId)"
                            v-bind:key="lotto.lottoId">
                                <div class="loto-item-box">
                                    <div class="gamesm-content-left">{{lotto.name}}</div>
                                    <div class="gamesm-content-right">
                                    <div class="gamesm-text">{{lotto.count}}</div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        </li>
                    </ul>
                </div>

                <div v-if="tab == 'lottos'">
                <!-- loto item -->
                    <div class="gamesm-item"
                    v-for="lotto in lottosList"
                    v-on:click="selectLottos(lotto.lottoId)"
                    :class="(selectedLottos === lotto.lottoId) ? 'is-selected' : ''"
                    :key="lotto.lottoId">
                        <div class="gamesm-item-box"
                        :class="{'is-selected': (selectedLottos === lotto.lottoId)}">
                            <div class="gamesm-content-left">
                                <div class="filterLeft-icon">
                                    <span class="ggame-heading-icon lb-flag" :class="'flag-'+lottoMapping[lotto.lottoId]"> </span>
                                </div>
                                {{lotto.name}}
                            </div>
                            <div class="gamesm-content-right">
                                <div class="gamesm-text">{{lotto.count}}</div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
      </div>
      <div class="group-offer-l loto" v-if="!isMobile">
          <ResultsPageRoutes v-if="!isMobile" v-on:toggleCalendar="toggleCalendar" v-bind:showCalendar="showCalendar" />
          <div class="group-game" v-if="selectedLottos !== null && lottosDef[selectedLottos]">
              <div class="ggame-heading">
                  <span class="ggame-heading-icon" :class="'lotto-icon-'+lottoMapping[lottosDef[selectedLottos][0].lottoId]"> </span>
                  <h2 class="ggame-heading-text">{{lottosDef[selectedLottos][0].name}}</h2>
              </div>
              <div class="ggame-item loto-res"
              v-for="draw in lottosDef[selectedLottos]"
              :key="draw.lottoOfferId">
                  <div class="ggame-content">
                    <div class="ggame-item-text loto">{{$t('DRAW')}}: {{draw.dateTime | getLocalDate}}</div>
                    <div class="lotto-results-numbers-container" v-if="draw.results !== null && draw.results !== ''">
                        <div class="lotto-results-numbers" v-for="val in draw.results.split(',')" :key="val">
                            <div class="results-loto-balls no-hover">
                                <div class="loto-number-box">
                                    <div class="loto-big-num small">
                                        <div class="loto-big-num-inner small">{{val}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ggame-item-text loto" v-else>{{$t('LOTTODRAWRESULTSNOTAVAILABLE')}}</div>

                  </div>
              </div>
          </div>
          <div v-else-if="!loading" class="group-game empty">
            <div class="error-offer-loading">
                <img class="odd-stats-img" src="../../assets/img/error-offer-loading.svg" alt="">
                <p>{{$t('NOLOTTORESULTSFORTHISFILTER')}}</p>
            </div>
          </div>
      </div>
    </div>
    <div class="loto-menu lottoresults-list" v-if="isMobile">
      <div class="loto-menu-item" v-for="lotto in lottosList" :key="lotto.lottoId">
          <div class="loto-menu-item-box"
          :class="{'is-selected': (selectedLottos === lotto.lottoId)}"
          v-on:click="selectLottos(lotto.lottoId)">
              <div class="loto-left-item">
                  <p>{{lotto.name}}</p>
              </div>
              <div class="loto-right-item">
                  <img class="loto-item-arrow" src="../../assets/img/arrow-down.svg" alt="">
              </div>
          </div>
          <div class="loto-submenu-box" v-if="selectedLottos !== null && lotto.lottoId === selectedLottos">
              <div class="loto-submenu-item"
              v-for="draw in lottosDef[selectedLottos]"
              :key="draw.lottoOfferId">
                <div class="loto-submenu-content results" v-on:click="toggleResults(draw)" :key="draw.lottoOfferId">
                  <div class="loto-submenu-item-left">
                      {{$t('DRAWTIME')}}: {{draw.dateTime | getLocalDate}}
                  </div>
                  <div class="loto-submenu-item-right">
                      {{$t('DRAW')}}: ({{draw.lottoOfferId}})
                  </div>
                </div>
                <div class="loto-submenu-content results" v-if="draw.results !== null && draw.results !== ''">{{draw.results}}</div>
                <div class="loto-submenu-content results" v-else>{{$t('LOTTODRAWRESULTSNOTAVAILABLE')}}</div>
              </div>
          </div>
      </div>
        <div v-if="!loading && !lottosList.length" class="group-game empty">
            <div class="error-offer-loading">
                <img class="odd-stats-img" src="../../assets/img/error-offer-loading.svg" alt="">
                <p>{{$t('NOLOTTORESULTSFORTHISFILTER')}}</p>
            </div>
        </div>
    </div>
    <div class="results-menu-l lotto-results-desktop" v-if="!isMobile">
      <router-link v-if="showLottoOfferButton"
      class="button button-grey-first button-mobileLoto button-results-lotto full"
      :to="{ path: '/web/lotto/' }">
        {{$t('LOTTOOFFER')}}
    </router-link>
      <div class="results-menu-subcontainer">
        <Calendar :otherStartDate="startDate" v-on:selectDate="changeDate"></Calendar>
      </div>
    </div>
  </div>
</template>

<script>
import {
    mapActions,
    mapGetters,
} from 'vuex';

import moment from 'moment-timezone';
import Calendar from '../components/Calendar.vue';
import ResultsPageRoutes from './containers/ResultsPageRoutes.vue';

export default {
    name: 'LottoResults',
    components:
    {
        Calendar,
        ResultsPageRoutes,
    },
    data()
    {
        return {
            lottos: {},
            lottosDef: {},
            lottosList: [],
            countriesList: [],
            selectedLottos: null,
            loading: false,
            showCalendar: false,
            startDate: moment().set({ hours: 0, minutes: 0, seconds: 0 }),
            endDate: moment().add(1, 'day').set({ hours: 0, minutes: 0, seconds: 0 }),
            countries: {},
            tab: 'lottos',
        };
    },
    created()
    {
        const me = this;

        me.getOfferByDate();
    },
    computed:
    {
        ...mapGetters([
            'globals',
            'isMobile',
            'offerHandling',
        ]),
        lottoMapping()
        {
            const me = this;
            let val = {};

            if (me.globals
            && me.globals.props
            && me.globals.props.lottoMapping)
            {
                val = me.globals.props.lottoMapping;
            }

            return val;
        },
        showLottoOfferButton()
        {
            const me = this;

            if (me.globals
            && me.globals.publicConfig != null
            && me.globals.publicConfig.website != null
            && me.globals.publicConfig.website
            && me.globals.publicConfig.website.extraButtonOptions
            && me.globals.publicConfig.website.extraButtonOptions.displayLottoOfferButtonOnResults)
            {
                return true;
            }

            return false;
        },
    },
    methods:
    {
        ...mapActions([]),
        toggleCalendar()
        {
            const me = this;
            me.showCalendar = !me.showCalendar;
        },
        changeDate(val)
        {
            const me = this;
            me.startDate = val;
        },
        toggleResults(draw)
        {
            draw.showResults = !draw.showResults;
        },
        selectLottos(lottoId)
        {
            const me = this;
            let lottoIdOut = lottoId;

            if ((me.isMobile && me.selectedLottos === lottoIdOut) || lottoId === null)
            {
                lottoIdOut = null;
            }

            me.selectedLottos = lottoIdOut;
        },
        async getOfferByDate()
        {
            const me = this;

            if (me.startDate === false)
            {
                return;
            }

            me.loading = true;

            let startDate = moment(me.startDate).set({ hours: 0, minutes: 0, seconds: 0 });
            startDate = moment.utc(startDate).format('YYYY-MM-DD HH:mm:ss');

            let endDate = moment(me.startDate).add(1, 'day').set({ hours: 0, minutes: 0, seconds: 0 });
            endDate = moment.utc(endDate).format('YYYY-MM-DD HH:mm:ss');

            const params = {
                currentStatus: 'active',
                startDate,
                endDate,
            };

            const data = await me.offerHandling.callOffer(
                `/${me.globals.langCode}/lotto/getLottoResults`,
                params,
            );

            me.lottos = {};
            me.selectedLottos = null;

            const lottos = data.data;
            const lottosOut = {};

            for (const lotto of lottos)
            {
                lotto.showResults = false;
                lottosOut[lotto.lottoOfferId] = lotto;
            }

            me.lottos = lottosOut;
            me.loading = false;
        },
    },
    watch:
    {
        isMobile(val)
        {
            const me = this;
            if (!val)
            {
                if (me.selectedLottos !== null
                || (me.lottosDef[Object.keys(me.lottosDef)[0]] !== undefined
                && me.lottosDef[Object.keys(me.lottosDef)[0]][0]))
                {
                    me.selectLottos(me.lottosDef[Object.keys(me.lottosDef)[0]][0].lottoId);
                }
            }
        },
        lottosList(val)
        {
            const me = this;

            if (val[0] !== undefined && me.selectedLottos === null)
            {
                me.selectLottos(val[0].lottoId);
            }
        },
        startDate(val)
        {
            const me = this;
            if (val === false)
            {
                return;
            }

            me.getOfferByDate();
        },
        lottos()
        {
            const me = this;
            const lottoOut = {};
            const lottosDefOut = {};
            const lottosList = [];
            const countriesList = [];
            const nowDate = moment.utc();

            for (const lottoId in me.lottos)
            {
                if (me.lottos[lottoId] !== undefined)
                {
                    const lotto = me.lottos[lottoId];

                    if (moment.utc(lotto.endBet) < nowDate)
                    {
                        continue;
                    }

                    const tempLotto = {
                        lottoId: lotto.lottoId,
                        lottoOfferId: lotto.lottoOfferId,
                        dateTime: lotto.dateTime,
                        name: lotto.name,
                        orderNum: lotto.orderNum,
                        code: lotto.code,
                        results: lotto.results,
                    };

                    if (lottosDefOut[tempLotto.lottoId] === undefined)
                    {
                        lottosDefOut[tempLotto.lottoId] = [];
                    }

                    lottosDefOut[tempLotto.lottoId].push(tempLotto);

                    const { countryId } = lotto;
                    const { countryName } = lotto;

                    if (lottoOut[countryId] === undefined)
                    {
                        const isCountrySelected = (me.countries[countryId] !== undefined
                        && me.countries[countryId].selected)
                        || false;

                        lottoOut[countryId] = {
                            name: countryName,
                            selected: isCountrySelected,
                            lottoId: lotto.lottoId,
                            lottos: {},
                            lottosList: [],
                        };

                        countriesList.push(
                            {
                                name: countryName,
                                lottoId: lotto.lottoId,
                                countryId,
                            },
                        );
                    }

                    if (lottoOut[countryId].lottos[lotto.lottoId] === undefined)
                    {
                        lottoOut[countryId].lottos[lotto.lottoId] = {
                            lottoId: lotto.lottoId,
                            name: lotto.name,
                            count: 0,
                            orderNum: lotto.orderNum,
                        };
                    }

                    lottoOut[countryId].lottos[lotto.lottoId].count += 1;
                }
            }

            for (const lottoId in lottosDefOut)
            {
                if (lottosDefOut[lottoId] !== undefined)
                {
                    if (lottosDefOut[lottoId][0] !== undefined)
                    {
                        const lottoOutTemp = lottosDefOut[lottoId][0];
                        lottosList.push(
                            {
                                lottoId,
                                dateTime: lottoOutTemp.dateTime,
                                name: lottoOutTemp.name,
                                count: lottosDefOut[lottoId].length,
                                countryId: lottoOutTemp.countryId,
                                orderNum: lottoOutTemp.orderNum,
                            },
                        );
                    }

                    lottosDefOut[lottoId].sort((a, b) =>
                    {
                        const as = moment(a.dateTime);
                        const bs = moment(b.dateTime);

                        if (as < bs)
                        {
                            return -1;
                        }

                        if (as > bs)
                        {
                            return 1;
                        }

                        return 0;
                    });
                }
            }

            for (const countryId in lottoOut)
            {
                if (lottoOut[countryId] !== undefined)
                {
                    const countryLottos = lottoOut[countryId];

                    for (const lottoIdCountry in countryLottos.lottos)
                    {
                        if (countryLottos.lottos[lottoIdCountry] !== undefined)
                        {
                            lottoOut[countryId].lottosList.push(
                                {
                                    name: countryLottos.lottos[lottoIdCountry].name,
                                    lottoId: lottoIdCountry,
                                    count: countryLottos.lottos[lottoIdCountry].count,
                                },
                            );
                        }
                    }

                    lottoOut[countryId].lottosList.sort((a, b) =>
                    {
                        const compare = a.name.localeCompare(b.name);

                        return compare;
                    });
                }
            }

            lottosList.sort((a, b) =>
            {
                const compare = a.name.localeCompare(b.name);

                return compare;
            });

            countriesList.sort((a, b) =>
            {
                const compare = a.name.localeCompare(b.name);

                return compare;
            });

            me.countries = Object.assign(lottoOut, {}, {});
            me.lottosDef = Object.assign(lottosDefOut, {}, {});
            me.lottosList = lottosList;
            me.countriesList = countriesList;
        },
    },
};
</script>
